// src/App.tsx
import { BrowserRouter, useLocation } from "react-router-dom";
import { useEffect } from "react";

import AppRoutes from "./routes/AppRoutes";
import { CartProvider } from "./contexts/CartProvider";
import { LoaderProvider, useGlobalLoader } from "./providers/LoaderProvider";
import { AuthProvider } from "./contexts/AuthProvider";
import MiniCartDrawer from "./components/cart/MiniCartDrawer";

/* ======================
   ROUTE CHANGE LOADER
   → CHẠY MỖI KHI ĐỔI PAGE
   → BỎ QUA /lookbook
====================== */
function RouteChangeLoader() {
  const location = useLocation();
  const loader = useGlobalLoader();

  useEffect(() => {
    // ❌ Lookbook có loader riêng → bỏ qua
    if (location.pathname.startsWith("/lookbook")) return;

    loader.show({
      label: "OWL DREAM",
      title: "OWL DREAM",
      subtitle: "dream in the dark",
      duration: 650,
    });
  }, [location.pathname]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <LoaderProvider>
        <AuthProvider>
          <CartProvider>
            {/* ROUTE CHANGE LOADER */}
            <RouteChangeLoader />

            {/* ROUTES */}
            <AppRoutes />

            {/* ✅ GLOBAL MINI CART (PHẢI Ở ĐÂY) */}
            <MiniCartDrawer />
          </CartProvider>
        </AuthProvider>
      </LoaderProvider>
    </BrowserRouter>
  );
}
